<template>
  <v-dialog v-model="displayModal" @keydown.esc="$emit('cancelled')" max-width="400">
    <v-card>
      <v-card-text class="pa-4 black--text text-center">{{ message }}</v-card-text>
      <v-card-actions class="pt-3 d-flex justify-center">
        <v-btn color="grey" text class="body-2 font-weight-bold mr-10" outlined @click="$emit('cancelled')">
          {{ $t('interface.dialog.confirm.cancel') }}
        </v-btn>
        <v-btn color="primary" class="font-weight-bold" @click="$emit('accepted')" role="button">
          {{ $t('interface.dialog.confirm.accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmDialog',
  props: {
    display: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    displayModal: {
      get(): boolean {
        return this.display;
      },
      set(newValue: boolean | null) {}
    }
  }
});
</script>
